import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import * as React from 'react';
import { cn } from '../../../lib/utils';
import { SpecraScheduleRow } from '../lieutenants/schedule-row';
import { SpecraSectionHeader } from '../lieutenants/section-header';
/** Percentage-based schedule visualization for periods and option coverage. */ export function SpecraGantt({ 'aria-labelledby': ariaLabelledby, action, className, getRowProps, getRowTestId, markers = [], rows, title, ...props }) {
    const generatedHeadingId = React.useId();
    const headingId = ariaLabelledby ?? `specra-gantt-${generatedHeadingId}-heading`;
    return /*#__PURE__*/ _jsxs("section", {
        ...props,
        "aria-labelledby": headingId,
        className: cn('rounded-lg bg-muted/40 p-4 sm:p-5', className),
        children: [
            /*#__PURE__*/ _jsx(SpecraSectionHeader, {
                action: action,
                headingId: headingId,
                title: title
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "max-w-full overflow-x-auto [scrollbar-width:thin]",
                children: /*#__PURE__*/ _jsx("div", {
                    className: "grid min-w-[var(--component-gantt-min-width)] grid-cols-[minmax(var(--component-gantt-label-min-width),var(--component-gantt-label-max-width))_minmax(var(--component-gantt-track-min-width),1fr)] gap-x-4",
                    children: rows.map((row)=>{
                        const rowProps = getRowProps?.(row);
                        return /*#__PURE__*/ _createElement("div", {
                            ...rowProps,
                            className: "contents",
                            "data-row-id": row.id,
                            "data-testid": getRowTestId?.(row),
                            key: row.id
                        }, /*#__PURE__*/ _jsx(SpecraScheduleRow, {
                            ...row,
                            markers: markers
                        }));
                    })
                })
            })
        ]
    });
}
